import styled from 'styled-components';

export const EditButtonStyles = styled.div`
  .ant-btn {
    border: 0px !important;
    color: ${({ theme }) => theme.text.mainL2} !important;
    background: transparent !important;
    box-shadow: none !important;
    height: 32px !important;
    width: 32px !important;
    min-width: 32px !important;
    .anticon {
      line-height: 1;
      font-size: 20px;
      color: ${({ theme }) => theme.text.mainL3};
    }
    &:hover,
    &:focus {
      background: transparent;
      transform: scale(1.1, 1.1);
      .anticon {
        color: ${({ theme }) => theme.palette.primary} !important;
      }
    }
  }

  .edit-action-wrapper {
    position: relative;
  }

  .action-feature-icon {
    position: absolute;
    top: -5px;
    right: 0px;
    font-size: 18px;
    color: ${({ theme }) => theme.subscriptions.colorIcon};
  }
`;
